import expandTextAnnotationToFit from './expandTextAnnotationsToFitContent';
import fitTextAnnotationToContent from './fitTextAnnotationToContent';
import { TOOLS_IDS } from './constants';
import { buildCardBackgroundPatchForText } from './textTemplateCardLayout';

/**
 * Apply new copy, resize the text box, and keep a linked card background in sync.
 * @returns {{ text: object, card?: object } | null}
 */
const mergeTextAnnotationContentWithFit = (annotations, annotation, text) => {
  if (!annotation || annotation.name !== TOOLS_IDS.TEXT) {
    return null;
  }
  const merged = { ...annotation, text };
  const fitted = fitTextAnnotationToContent(merged);
  const textResult = fitted || expandTextAnnotationToFit(merged);
  const card = buildCardBackgroundPatchForText(annotations, textResult);
  return card ? { text: textResult, card } : { text: textResult };
};

export default mergeTextAnnotationContentWithFit;
